var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AddCourse',{key:_vm.updateCourse,attrs:{"update":""},on:{"update":function($event){_vm.updateCourse = !_vm.updateCourse}}}),_c('Toast',{attrs:{"title":"بروزرسانی با موفقیت انجام شد","showToast":_vm.showToast}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }